import { useState } from "react"
import { AnimatePresence } from "framer-motion"
import GallerySlider from "components/Slider/GallerySlider"
import CustomImage from "components/atoms/Image/CustomImage"

interface Props {
    images: string[]
}

const F1GalleryComponent = ({ images }: Props) => {
    const [isClicked, setIsClicked] = useState({
        open: false,
        index: 0,
    })

    if (!images || images.length === 0) return null

    return (
        <div className="flex flex-col">
            <div className="flex flex-wrap p-2 pl-0 pt-0 max-w-2xl">
                {images.map((poster: string, i: number) => (
                    <div
                        key={i}
                        onClick={() =>
                            setIsClicked({
                                open: true,
                                index: i,
                            })
                        }
                        className="w-1/2 p-1 pt-0 pb-2 pl-0 pr-2 flex justify-center cursor-pointer"
                    >
                        <div className="relative w-full aspect-video">
                            <CustomImage
                                src={`${process.env.NEXT_PUBLIC_Event_Img_URL}${poster}`}
                                alt={`Image ${i + 1}`}
                                fill
                                style={{
                                    objectFit: "cover",
                                }}
                                className="rounded-[5px]"
                            />
                        </div>
                    </div>
                ))}
            </div>

            <AnimatePresence>
                {isClicked.open ? (
                    <GallerySlider
                        images={images}
                        clickedIndex={isClicked.index}
                        close={() =>
                            setIsClicked({
                                open: false,
                                index: 0,
                            })
                        }
                    />
                ) : null}
            </AnimatePresence>
        </div>
    )
}

export default F1GalleryComponent
